define.alias("shared/components/shared/address-fields/suggestions", "settings/components/shared/address-fields/suggestions");